import { fetchTotalPurchases, fetchPurchaseOrdersNotReceived, fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder } from '../../actions/purchaseOrders_actions';
import { fetchWarehouseBins, fetchWarehouses, fetchWarehouseSalesOrders, fetchWarehousePurchaseOrders } from '../../actions/warehouses_actions';
import { fetchInventories, selectInventory, resetCurrentInventory } from '../../actions/inventories_actions';
import { fetchFavorites, selectFavorites, resetCurrentFavorites, deleteFavorite } from '../../actions/favorites_actions';
import { fetchNumPurchaseQuotes } from '../../actions/purchaseQuotes_actions';
import { fetchBinListFromZone } from '../../actions/putAway_actions';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';



import ZoneInformation from '../../components/Inventories/zoneInformation';

let zoneInformation = reduxForm({
    form: 'zoneInformation',
})(ZoneInformation);

const selector = formValueSelector('zoneInformation');

function mapStateToProps(state) {
    const warehouseChosen = selector(state, 'Warehouse');

    return {
        warehouseChosen,

        salesOrders: state.warehouses.salesOrders,
        SOIsLoading: state.warehouses.salesOrdersIsLoading,
        SOError: state.warehouses.salesOrdersError,

        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,

        purchaseOrders: state.warehouses.purchaseOrders,
        POIsLoading: state.warehouses.purchaseOrdersIsLoading,
        POError: state.warehouses.purchaseOrdersError,

        warehouses: state.warehouses.all,
        warehousesIsLoading: state.warehouses.isLoading,
        warehousesError: state.warehouses.error,

        warehouseBinsDetail: state.warehouses.warehouseBinsDetail,
        warehouseBinsDetailIsLoading: state.warehouses.warehouseBinsDetailIsLoading,
        warehouseBinsDetailError: state.warehouses.warehouseBinsDetailError,

        inventories: state.inventories.all,
        favorites: state.favorites.all,
        inventoryIsLoading: state.inventories.isLoading,
        favoritesAreLoading: state.favorites.isLoading,
        inventoryError: state.inventories.error,
        favoritesError: state.favorites.error,
        currentInventory: state.inventories.currentInventory,
        currentFavorites: state.favorites.currentFavorites,

        numPurchaseQuotes: state.purchaseQuotes.numPurchaseQuotes,
        numPurchaseQuotesLoading: state.purchaseQuotes.numPurchaseQuotesLoading,
        numPurchaseQuotesError: state.purchaseQuotes.numPurchaseQuotesError,
        numPurchaseOrdersNotReceived: state.purchaseOrders.numPurchaseOrdersNotReceived,
        numPurchaseOrdersNotReceivedLoading: state.purchaseOrders.numPurchaseOrdersNotReceivedLoading,
        numPurchaseOrdersNotReceivedError: state.purchaseOrders.numPurchaseOrdersNotReceivedError,
        numTotalPurchases: state.purchaseOrders.numTotalPurchases,
        numTotalPurchasesError: state.purchaseOrders.numTotalPurchasesError,
        numTotalPurchasesLoading: state.purchaseOrders.numTotalPurchasesLoading,
        currentWarehouseReceive: state.putAway.currentWarehouseReceive
    };
}

export default connect(mapStateToProps, { fetchBinListFromZone, fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder,
                                            fetchInventories, fetchFavorites, selectInventory, selectFavorites,
                                             resetCurrentInventory, resetCurrentFavorites, deleteFavorite,
                                              fetchNumPurchaseQuotes, fetchPurchaseOrdersNotReceived, fetchTotalPurchases,
                                               fetchWarehouses, fetchWarehouseSalesOrders, fetchWarehousePurchaseOrders,
                                                fetchWarehouseBins })(zoneInformation);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/zoneInformation.jsx